<div class="about-us-page-container flex justify-center">
    <div class="about-us-page-content-wrapper pb-6 w-[80vw]">
        <div class="about-us-page-header-container mb-4">
            <div class="about-us-resources-container">
                <div *ngFor="let item of documentsForHandBookAndIOSCOInfo()" class="resource-wrapper">
                    <div class="labels-container">
                        <div class="company-label">BNP PARIBAS</div>
                        <div class="document-label">{{item.Title}}</div>
                    </div>
                    <a href="javascript:void(0)"  class="resource-link" (click)="onDownloadDocument(item)">
                        <img width="25px" height="29px" src="{{ deployUrlHost }}/assets/PDF_icon.png" alt="">
                    </a>
                </div>
            </div>
        </div>
        <div class="about-us-page-title px-3 py-3 mb-4 text-lg">
            <span class="page-title">About Us</span>
        </div>
        <div class="about-us-page-description mb-4 text-sm">
            <p>
                BNP Paribas Global Markets offers consistent client service and innovative solutions for investment,
                hedging and financing opportunities. Our integrated platform ensures clients have everything they need
                in one place, across asset classes and across the world.<br><br>
                While our business has evolved around client needs, we have stayed true to our roots offering stability
                in a changing environment. Global Markets can be relied upon to deliver best in class derivatives
                solutions, strong financing and balance sheet capabilities, stability and commitment to markets for the
                long term.<br><br>
                To learn more about BNP Paribas Global Markets, <a href="https://globalmarkets.cib.bnpparibas/"
                    class="underline">please
                    visit their website</a>.

            </p>
        </div>

        <div class="qis-info-banner-container">
            <img width="150" src="{{ deployUrlHost }}/assets/QIS_logo.png" alt="">
            <div class="qis-description text-sm">
                The QIS Team is a transversal group within BNP Paribas Global Markets focused exclusively on the
                development and implementation of systematic strategies.
            </div>
        </div>

        <div class="metrics-data-container py-1">
            <div class="metrics-description-container w-[50%] p-4">
                <section>
                    <h3 class="section-title text-base">Systematic</h3>
                    <ul class="text-sm">
                        <li>Data-driven approach, insulated from human behavioral biases</li>
                        <li>Tested strategies, backed by proprietary research</li>
                        <li>ESG Integration / ESG Focus where possible </li>
                    </ul>
                </section>
                <section>
                    <h3 class="section-title text-base">COST-EFFICIENT</h3>
                    <div class="section-description text-sm">Cost-efficient implementation relies on the strong
                        execution
                        capabilities and positions in the future/option markets
                    </div>
                </section>
                <section>
                    <h3 class="section-title text-base">LIQUID</h3>
                    <div class="section-description text-sm">BNP Paribas’s commitment to providing liquidity and
                        competitive
                        bid/ask spreads including in stressed markets
                    </div>
                </section>
                <div class="logo-container mt-2">
                    <img src="{{ deployUrlHost }}/assets/star_logo.png" alt="">
                    <img src="{{ deployUrlHost }}/assets/world_logo.png" alt="">
                    <img src="{{ deployUrlHost }}/assets/soc_logo.png" alt="">
                </div>
            </div>
            <div class="metrics-table-container w-[50%]">
                <img max-height="400" src="{{ deployUrlHost }}/assets/thematic-esg-table.png" alt="">
            </div>
        </div>
    </div>
</div>
